import { Config } from "./Config";

export class ResponsePage {
    content: Array<any> = [];
    first: boolean;
    last: boolean;
    number: number = 0; //page number
    numberOfElements: number = 0;
    size: number = Config.PAGE_SIZE_OPTIONS[0];
    sort: Array<any> = [];
    totalElements: number = 0;
    totalPages: number = 0;
}